import { useSelector } from 'react-redux'
import { useCurrentRoute } from '../../../hooks/getReduxData/useCurrentRoute'
import { getTranTypeIcon, selectSelector } from '../../../redux/slices/select'
import { tranRoutesSelector } from '../../../redux/slices/tranRoutes'
// import KeyValueInfo from '../../reusable/Info/KeyValueInfo'
import OnMapIcon from './on_map.svg'

const RoutesHeader = () => {
  const {
    currentTransport: { id, tranTitle } = {},
  } = useSelector(selectSelector)
  const TranIcon = getTranTypeIcon(id)

  const { route_id } = useSelector(tranRoutesSelector)
  const { number = '' } = useCurrentRoute(route_id)

  const handleMap = () => {}

  return (
    <div className="routes_block_header">
      <div className="route_transport">
        {TranIcon && <TranIcon className="route_transport_icon" />}
        <span className="route_transport_title">
          {tranTitle} {number}
        </span>
      </div>

      {/* <KeyValueInfo infoKey="Перевізник" infoValue='KП "Київпастранс"' blueValue />
      <KeyValueInfo infoKey="Вартість проїзду" infoValue="8 UAH" />
      <KeyValueInfo infoKey="Час роботи" infoValue="6:00 - 23:19" /> */}

      <div className="on_map" onClick={handleMap}>
        <img src={OnMapIcon} alt="" className="on_map_icon" />
        <span className="on_map_title">Переглянути на мапі</span>
      </div>
    </div>
  )
}

export default RoutesHeader
